import React, { useEffect, useState, useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { config } from "config";
import adminSocket from "store/adminSocket";

import {
  fetchAllClientsVersionStart,
  updateClientVersionStart,
  addClientVersionStart
} from "store/actions";

import "./VersionAddAndUpdate.css";

const actions = [
  "adminSendErrorReport",
  "adminStartCloudBackup",
  "adminStartForceFullCloudBackup"
];

function Pns(props) {
  const [wsConnectionAdmin, setwsConnectionAdmin] = useState(null);
  const [formState, setFormState] = useState({
    mirrorId: "",
    clientUUID: "",
    action: actions && actions[0]
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    setwsConnectionAdmin(adminSocket());
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormState({ ...formState, [name]: value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    sendPNSMessage({
      action: formState.action,
      data: JSON.stringify({ clientUUIDs: formState.clientUUID.split(",") }),
      loginId: formState.mirrorId
    });
  };

  function sendPNSMessage(req) {
    const { wsConnection } = wsConnectionAdmin;
    wsConnection.send(JSON.stringify(req));
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 3000);
  }

  return (
    <React.Fragment>
      <br />
      <h2 style={{ marginLeft: "10%" }}>Admin PNS Control</h2>
      <br />
      <br />
      <form id="versionForm" onSubmit={handleSubmit}>
        <ul>
          <li>
            <label htmlFor="name">Mirror ID : </label>
            <input
              type="text"
              name="mirrorId"
              value={formState.mirrorId}
              onChange={handleChange}
              required
            />
          </li>
          <li>
            <label htmlFor="versionNumber">clientUUID : </label>
            <textarea
              rows="20"
              cols="38"
              name="clientUUID"
              value={formState.clientUUID}
              onChange={handleChange}
              placeholder="Enter comma separated values"
              required
            />
          </li>
          <li>
            <label htmlFor="name">Select Action : </label>
            <select
              style={{ WebkitAppearance: "auto", MozAppearance: "auto" }}
              name="action"
              onChange={handleChange}
              required
              defaultValue={actions && actions[0]}
            >
              {actions &&
                actions.map((val, index) => (
                  <option value={val} key={index}>
                    {val}
                  </option>
                ))}
            </select>
          </li>
          <li>
            <label />
            <input type="submit" value="Send" />
          </li>
          <li>
            <label />
            {showSuccessMessage && (
              <p style={{ color: "green" }}> Message sent successfully</p>
            )}
          </li>
        </ul>
      </form>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    versionInfo: state.auth.versionInfo
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAllClientsVersionStart,
      updateClientVersionStart,
      addClientVersionStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Pns);
